import axios from 'axios';

const API = process.env.VUE_APP_BASE_URI;

export default {
    addPermission({
        commit
    }, permission_data) {
        return new Promise((resolve, reject) => {
            let axiosCall = permission_data && permission_data.id ?
                axios.put(`${API}/permission/${permission_data.id}`, permission_data) :
                axios.post(`${API}/permission`, permission_data);

            axiosCall.then(({
                    data
                }) => {
                    //then assign roles to permission
                    commit("ADD_PERMISSION", data)
                    resolve(data.success);
                })
                .catch(error => reject(error.response))
        })
    },
    getPermissions({
        commit
    }, params = undefined) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/permission?${params}`)
                .then(({
                    data: {
                        data
                    }
                }) => {
                    commit("SET_PERMISSIONS", data);
                    resolve(data)
                }).catch(error => reject(error.response))
        })
    },
    getPermissionsTotal({
        commit
    }, params = undefined) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/permission?${params}`)
                .then(({
                    data
                }) => {
                    resolve(data.total)
                }).catch(error => reject(error.response))
        })
    },
    getPermission({
        commit
    }, permission_id) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/permission/${permission_id}`)
                .then(({
                    data
                }) => {
                    resolve(data)
                })
                .catch(error => reject(error.response))
        })
    },
    assignPermissionsToRoles({
        commit
    }, permission_data) {
        return new Promise((resolve, reject) => {
            axios.put(`${API}/role/${permission_data.role_id}/permissions`, permission_data)
                .then(({
                    data
                }) => {
                    resolve(data.success);
                })
                .catch(error => reject(error.response))
        })
    },
    assignPermissionToUsers({
        commit
    }, permission_data) {
        return new Promise((resolve, reject) => {
            axios.put(`${API}/user/${permission_data.user_id}/permissions`, permission_data)
                .then(({
                    data
                }) => {
                    resolve(data.success);
                })
                .catch(error => reject(error.response))
        })
    },

}